angular.module('dnecom')
    .controller('StoreAppearanceSettingsController', ["$scope", "$http", "notifications", "ErrorBag", function ($scope, $http, notifications, ErrorBag) {
        $scope.store = TemplateData.value('store');

        $scope.defaultProperties = TemplateData.value('defaultProperties');
        $scope.translations = TemplateData.value('storeLabels');
        for (const [key, value] of Object.entries($scope.translations)) {
            if (Array.isArray($scope.translations[key])) {
                $scope.translations[key] = {};
            }
        }

        $scope.originalStore = angular.copy($scope.store);
        $scope.originalTranslations = angular.copy($scope.translations);

        $scope.view_tab = 'AppearanceGeneral';

        $scope.formHolder = {};
        $scope.saving = false;

        var scrollToTop = function () {
            $('html,body').animate({scrollTop: $('.settings-container').offset().top}, 'slow');
        };

        var validateForm = function (form) {
            if (form.$invalid || form.$pending) {
                form.$setTouched();

                scrollToTop();

                return false;
            }

            return true;
        };

        var saveSettings = function (form) {
            if (!validateForm(form)) {
                return false;
            }

            $scope.serverErrors = {};
            $scope.saving = true;
            $http.put(
                Routing.generate('stores_update_settings', { id: $scope.store.id, group: $scope.view_tab }),
                $scope.store
            )
            .then(function (response) {
                if (response.data.success) {
                    notifications.success('Store appearance settings saved.');
                } else {
                    notifications.danger(response.data.message);
                }
            }, function (response) {
                if (response.status == 422) {
                    notifications.danger('Form contains invalid data.');

                    $scope.serverErrors = ErrorBag.from(response.data.errors);
                } else {
                    notifications.danger('Request error.');
                }
            })
            .finally(function() {
                $scope.saving = false;
            });

            copyCurrentStore();

            return true;
        };

        var cancelSave = function () {
            $scope.store = angular.copy($scope.originalStore);

            notifications.info('Store appearance settings reset completed.');
        };

        var copyCurrentStore = function () {
            $scope.originalStore = angular.copy($scope.store);
        };

        $scope.changeTab = function(form, tab) {
            if (!angular.equals($scope.store, $scope.originalStore)) {
                if (confirm('Save changes? Otherwise it will be lost.')) {
                    if (!saveSettings(form)) {
                        return;
                    }
                } else {
                    cancelSave();
                }
            }
            if (!angular.equals($scope.originalTranslations, $scope.translations)) {
                if (confirm('Save changes? Otherwise it will be lost.')) {
                    $scope.$broadcast('store:trans:forceSave')
                } else {
                    $scope.translations = angular.copy($scope.originalTranslations);
                    $scope.$broadcast('store:trans:revert', $scope.originalTranslations)
                    notifications.info('Store labels reset completed.');
                }
            }

            $scope.view_tab = tab;
            if (tab === 'KiboHomePage') {
                $scope.$broadcast('cropper:init');
            }
        };

        $scope.save = function (form) {
            return saveSettings(form);
        };

        $scope.reset = function () {
            cancelSave();
        };

        $scope.storeChanged = function () {
            return !angular.equals($scope.store, $scope.originalStore);
        };

        $scope.$on('store:trans:saved', function (evnt, data) {
            $scope.originalTranslations = data;
            $scope.translations = data;
        })

        $scope.$on('store:trans:changed', function (evnt, data) {
            $scope.translations = data;
        })
    }]);
